import single_room_preview from './single_room_preview.jpg'
import single_room from './single_room.jpg'

export { single_room_preview, single_room }



// WEBPACK FOOTER //
// ./src/features/Hotel/components/SingleRoom/images/index.js